// extracted by mini-css-extract-plugin
module.exports = {"main":"MarketplacePostingNudgeCard_main__4tvA0","textWrapper":"MarketplacePostingNudgeCard_textWrapper__TXajM"};